import type { SheetEntity } from './entity/sheetEntity';

import { repository } from '@/share';

const getDateMonthKey = (year: number, month: number): string => {
  const m = (`00${month}`).slice(-2);
  return `${year}-${m}`;
};

/**
 * getSheetMonthList
 * @param year 年
 * @param month 月
 * @param parentChildId parentChildId
 * @param token token
 * @returns 結果
 */
export const getSheetMonthList = async (
  year: number,
  month: number,
  parentChildId: string,
  token: string | null,
) => {
  const key: string = getDateMonthKey(year, month);
  const result = await repository.sheet.getListWithSubKey(
    `${parentChildId}#${key}`,
    token,
  );
  const items = result.items.map((v: SheetEntity) => v.toJson());
  return items;
};
